import { Box, Divider, styled, Typography } from '@mui/material';
import { withShowable } from '../../../../_global/lib/withShowable';

export const Flexbox = ({ children, ...props }: any) => {
  return (
    <Box display="flex" justifyContent="space-between" {...props}>
      {children}
    </Box>
  );
};

export const CaptionTypography = ({ children, ...props }: any) => (
  <Typography variant="caption" {...props}>
    {children}
  </Typography>
);

export const AccountDataTypography = styled(CaptionTypography)(
  ({ theme: { palette, config } }) => ({
    color: config.colors.cowbellBlue,
    lineHeight: 1.2,
  })
);

// @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
export const AccountData = withShowable(({ data, children }) => {
  return (
    <>
      <Divider style={{ width: '100%', margin: '0.25rem 0' }} />
      <AccountDataTypography>{data || children}</AccountDataTypography>
    </>
  );
});
